import { useTranslation } from "react-i18next";
import { UpdateEvent } from "../../../api/models";
import { PagedApiState } from "../../../api/useApiState";
import "../../../styles/card.scss";
import { BaseDrawer } from "../../BaseDrawer";
import { BeaconEventTable } from "./EventTable";

interface BeaconEventDrawerProps {
  eventHistory: PagedApiState<UpdateEvent>;
  eventDrawerVisible: boolean;
  onCloseDrawer: (visible: boolean) => void;
}

export function BeaconEventDrawer({
  eventHistory,
  eventDrawerVisible,
  onCloseDrawer,
}: BeaconEventDrawerProps) {
  const { t } = useTranslation();
  const closeDrawer = () => {
    onCloseDrawer(false);
  };

  return (
    <BaseDrawer
      title={t("beacon:events")}
      drawerVisible={eventDrawerVisible}
      dataTestId="beacon-event-drawer"
      onCloseDrawer={closeDrawer}
    >
      <BeaconEventTable eventHistory={eventHistory} />
    </BaseDrawer>
  );
}
